import { Center, VStack, Text } from '@chakra-ui/react';

const PassesEmptyState = ({
  iconSvg,
  heading,
  text,
  children,
}: {
  iconSvg: React.ReactNode;
  heading: string;
  text: string;
  children?: React.ReactNode;
}) => {
  return (
    <Center flex="1" alignItems="flex-start" pt="10vh">
      <VStack
        spacing={4}
        textAlign="center"
        maxW="470px"
        border="1px solid #D9D9D9"
        bg="white"
        borderRadius="8px"
        p="24px"
      >
        {iconSvg}
        <VStack spacing={3}>
          <Text textStyle="bodyFamilySemiBold" fontSize="16px" color="inkBlue">
            {heading}
          </Text>
          <Text whiteSpace="pre-line" color="#666666">
            {text}
          </Text>
        </VStack>
        {children}
      </VStack>
    </Center>
  );
};

export default PassesEmptyState;
